export const LOGOUT_USER = 'AUTH_LOGOUT_USER'
export const LOGIN_USER = 'AUTH_LOGIN_USER'
export const USER_LOAD = 'USER_LOAD'
export const USER_SET_IS_SWITCHING_HCS = 'USER_SET_IS_SWITCHING_HCS'
export const USER_SET_HAS_MANY_HCS = 'USER_SET_HAS_MANY_HCS'
export const USER_SET_CGU_VERSION = 'USER_SET_CGU_VERSION'
export const HCS_LOAD = 'HCS_LOAD'
export const HCS_PREFERENCES = 'HCS_PREFERENCES'
export const HCS_SET_HCS = 'HCS_SET_HCS'
export const SNACKBAR_DISPLAY = 'SNACKBAR_DISPLAY'
export const SNACKBAR_HIDE = 'SNACKBAR_HIDE'
export const USER_SET_FIRST_SEEN_DATE = 'USER_SET_FIRST_SEEN_DATE'
export const OPEN_HELP_MENU = 'OPEN_HELP_MENU'
export const OPENED_HELP_MENU = 'OPENED_HELP_MENU'
export const SET_DEFAULT_PAGINATION = 'SET_DEFAULT_PAGINATION'
export const SUPPORT_PHONE = '01.88.32.84.91'
